// frontend/src/components/EdaAnalysis/EdaSelector.tsx

import React from 'react';

interface Props {
  snapshots: any[];
  selectedSnapshot: any | null;
  onSelect: (snapshot: any) => void;
  loading: boolean;
}

export const EdaSelector: React.FC<Props> = ({
  snapshots,
  selectedSnapshot,
  onSelect,
  loading,
}) => {
  if (loading && snapshots.length === 0) {
    return (
      <div className="selector-loading" style={{ color: '#8899aa', padding: '20px' }}>
        Carregando snapshots EDA...
      </div>
    );
  }

  if (snapshots.length === 0) {
    return (
      <div style={{ color: '#8899aa', padding: '20px', textAlign: 'center' }}>
        Nenhum snapshot EDA disponível
      </div>
    );
  }

  const formatDate = (dateStr: string) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div style={{ marginBottom: '24px' }}>
      <h3 style={{ color: '#4fc3f7', marginBottom: '12px' }}>📂 Selecione um Snapshot EDA</h3>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '12px'
      }}>
        {snapshots.map((snapshot) => (
          <div
            key={snapshot.id}
            onClick={() => onSelect(snapshot)}
            style={{
              background: selectedSnapshot?.id === snapshot.id 
                ? 'rgba(79, 195, 247, 0.15)' 
                : 'rgba(15, 42, 74, 0.4)',
              borderRadius: '8px',
              padding: '12px 16px',
              border: selectedSnapshot?.id === snapshot.id 
                ? '1px solid #4fc3f7' 
                : '1px solid transparent',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              if (selectedSnapshot?.id !== snapshot.id) {
                e.currentTarget.style.borderColor = '#1a4a7a';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedSnapshot?.id !== snapshot.id) {
                e.currentTarget.style.borderColor = 'transparent';
              }
            }}
          >
            <div style={{ fontWeight: 600, color: '#4fc3f7' }}>
              {snapshot.dataset_name}
            </div>
            <div style={{ fontSize: '13px', color: '#8899aa', marginTop: '4px' }}>
              📊 {snapshot.rows_count?.toLocaleString() || 0} registros · 
              📋 {snapshot.columns_count || 0} colunas
            </div>
            <div style={{ fontSize: '12px', color: '#556677', marginTop: '4px' }}>
              🎯 {snapshot.target_name || 'Sem target'} · 
              📈 {snapshot.baseline_accuracy !== null ? `${(snapshot.baseline_accuracy * 100).toFixed(1)}%` : '-'}
            </div>
            <div style={{ fontSize: '11px', color: '#556677', marginTop: '4px' }}>
              {formatDate(snapshot.created_at)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};